import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M12.57 5.03a5.756 5.756 0 0 0-1.655-1.18c-.588-.272-1.332-.403-2.187-.403-.689 0-1.344.12-1.955.36-.61.24-1.143.578-1.598 1.015a4.678 4.678 0 0 0-1.1 1.593c-.266.623-.4 1.31-.4 2.074 0 .764.134 1.452.4 2.074a4.633 4.633 0 0 0 1.1 1.582 5.09 5.09 0 0 0 1.62 1.026c.611.24 1.278.36 1.977.36.744 0 1.4-.098 1.954-.305a4.607 4.607 0 0 0 1.433-.84c.266-.24.51-.535.721-.885.211-.36.378-.753.5-1.19H8.683V7.693h7.662c.044.175.077.382.11.644.034.262.045.502.045.753 0 1.037-.155 1.976-.466 2.838a6.588 6.588 0 0 1-1.41 2.281 7.234 7.234 0 0 1-2.51 1.692c-.977.404-2.098.6-3.353.6a8.45 8.45 0 0 1-5.83-2.27 8.082 8.082 0 0 1-1.776-2.521C.711 10.737.5 9.657.5 8.5s.222-2.226.655-3.209A7.666 7.666 0 0 1 2.932 2.76c.744-.71 1.62-1.255 2.631-1.659A8.532 8.532 0 0 1 8.761.5c1.288 0 2.432.218 3.42.655a7.853 7.853 0 0 1 2.565 1.8L12.569 5.03z"
	})
});
export default SvgGoogle;
